
export let localesList = [
  {label: "Afrikaans", value: "af"},
  {label: "Albanian", value: "sq"},
  {label: "Arabic", value: "ar"},
  {label: "Arabic (Algeria)", value: "ar-dz"},
  {label: "Arabic (Kuwait)", value: "ar-kw"},
  {label: "Arabic (Libya)", value: "ar-ly"},
  {label: "Arabic (Morocco)", value: "ar-ma"},
  {label: "Arabic (Saudi Arabia)", value: "ar-sa"},
  {label: "Arabic (Tunisia)", value: "ar-tn"},
  {label: "Armenian", value: "hy-am"},
  {label: "Azerbaijani", value: "az"},
  {label: "Bambara", value: "bm"},
  {label: "Basque", value: "eu"},
  {label: "Belarusian", value: "be"},
  {label: "Bengali", value: "bn"},
  {label: "Bosnian", value: "bs"},
  {label: "Breton", value: "br"},
  {label: "Bulgarian", value: "bg"},
  {label: "Burmese", value: "my"},
  {label: "Cambodian", value: "km"},
  {label: "Catalan", value: "ca"},
  {label: "Chinese", value: "zh-cn"},
  {label: "Chinese (Hong Kong)", value: "zh-hk"},
  {label: "Chinese (Taiwan)", value: "zh-tw"},
  {label: "Chuvash", value: "cv"},
  {label: "Croatian", value: "hr"},
  {label: "Czech", value: "cs"},
  {label: "Danish", value: "da"},
  {label: "Divehi", value: "dv"},
  {label: "Dutch", value: "nl"},
  {label: "Dutch (Belgium)", value: "nl-be"},
  {label: "English (Australia)", value: "en-au"},
  {label: "English (Canada)", value: "en-ca"},
  {label: "English (Great Britain)", value: "en-gb"},
  {label: "English (Ireland)", value: "en-ie"},
  {label: "English (New Zealand)", value: "en-nz"},
  {label: "English (Singapore)", value: "en-SG"},
  {label: "English (United States)", value: "en"},
  {label: "Esperanto", value: "eo"},
  {label: "Estonian", value: "et"},
  {label: "Faroese", value: "fo"},
  {label: "Finnish", value: "fi"},
  {label: "French", value: "fr"},
  {label: "French (Canada)", value: "fr-ca"},
  {label: "French (Switzerland)", value: "fr-ch"},
  {label: "Galician", value: "gl"},
  {label: "Georgian", value: "ka"},
  {label: "German", value: "de"},
  {label: "German (Austria)", value: "de-at"},
  {label: "German (Switzerland)", value: "de-ch"},
  {label: "Greek", value: "el"},
  {label: "Gujarati", value: "gu"},
  {label: "Hebrew", value: "he"},
  {label: "Hindi", value: "hi"},
  {label: "Hungarian", value: "hu"},
  {label: "Icelandic", value: "is"},
  {label: "Indonesian", value: "id"},
  {label: "Irish", value: "ga"},
  {label: "Italian", value: "it"},
  {label: "Italian (Switzerland)", value: "it-ch"},
  {label: "Japanese", value: "ja"},
  {label: "Javanese", value: "jv"},
  {label: "Kannada", value: "kn"},
  {label: "Kazakh", value: "kk"},
  {label: "Kirghiz", value: "ky"},
  {label: "Korean", value: "ko"},
  {label: "Kurdish", value: "ku"},
  {label: "Laotian", value: "lo"},
  {label: "Latvian", value: "lv"},
  {label: "Lithuanian", value: "lt"},
  {label: "Luxembourgish", value: "lb"},
  {label: "Macedonian", value: "mk"},
  {label: "Malay", value: "ms"},
  {label: "Malayalam", value: "ml"},
  {label: "Maltese", value: "mt"},
  {label: "Maori", value: "mi"},
  {label: "Marathi", value: "mr"},
  {label: "Mongolian", value: "mn"},
  {label: "Nepali", value: "ne"},
  {label: "Northern Sami", value: "se"},
  {label: "Norwegian", value: "nn"},
  {label: "Persian", value: "fa"},
  {label: "Polish", value: "pl"},
  {label: "Portuguese", value: "pt"},
  {label: "Portuguese (Brazil)", value: "pt-br"},
  {label: "Punjabi", value: "pa-in"},
  {label: "Romanian", value: "ro"},
  {label: "Russian", value: "ru"},
  {label: "Scottish Gaelic", value: "gd"},
  {label: "Serbian", value: "sr"},
  {label: "Serbian (Cyrillic)", value: "sr-cyrl"},
  {label: "Sindhi", value: "sd"},
  {label: "Sinhalese", value: "si"},
  {label: "Slovak", value: "sk"},
  {label: "Slovenian", value: "sl"},
  {label: "Spanish", value: "es"},
  {label: "Spanish (Dominican Republic)", value: "es-do"},
  {label: "Spanish (United States)", value: "es-us"},
  {label: "Swahili", value: "sw"},
  {label: "Swati", value: "ss"},
  {label: "Swedish", value: "sv"},
  {label: "Tagalog", value: "tl-ph"},
  {label: "Tajik", value: "tg"},
  {label: "Tamil", value: "ta"},
  {label: "Telugu", value: "te"},
  {label: "Thai", value: "th"},
  {label: "Tibetan", value: "bo"},
  {label: "Turkish", value: "tr"},
  {label: "Ukrainian", value: "uk"},
  {label: "Urdu", value: "ur"},
  {label: "Uyghur", value: "ug-cn"},
  {label: "Uzbek", value: "uz-latn"},
  {label: "Uzbek (Cyrillic)", value: "uz"},
  {label: "Vietnamese", value: "vi"},
  {label: "Welsh", value: "cy"},
  {label: "West Frisian", value: "fy"},
  {label: "Yoruba", value: "yo"},
]
